import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from 'src/easyclaim.app.libs/queryKeys';
import { isAbortError, reportError } from 'src/easyclaim.app.libs/reportError';
import { deleteDocument, DeleteDocumentParams } from 'src/easyclaim.app.services/DocumentService';
import { usePhotoThumbnailStore } from 'src/easyclaim.app.stores/usePhotoThumbnailStore';

import { useIsPerformanceEnhancerEnabled } from './useIsPerformanceEnhancerEnabled';

export function useDeleteDocument() {
	const isEnabled = useIsPerformanceEnhancerEnabled();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		networkMode: 'always',
		mutationFn: (params: DeleteDocumentParams) => {
			if (!isEnabled) {
				return Promise.reject(
					new Error(
						'useDeleteDocument is disabled: canUseExperimentalPerformanceEnhancer is off for this customer.'
					)
				);
			}

			return deleteDocument(params);
		},
		onSuccess: (_, params) => {
			usePhotoThumbnailStore.getState().clearThumbnail(params.documentId);
			queryClient.removeQueries({
				queryKey: queryKeys.thumbnails.byImage(params.caseId, params.documentId),
			});
		},
		onError: (error, params) => {
			if (!isEnabled || isAbortError(error)) {
				return;
			}

			reportError(error, {
				context: 'useDeleteDocument',
				caseId: params.caseId,
				documentId: params.documentId,
			});
		},
	});

	return { ...mutation, isEnabled };
}
